import { PlusOutlined } from "@ant-design/icons";
import { Image } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toLogin, toSignUp } from "../../../../apis/utils";
import CustomButton from "../../../../components/CustomButton";
import { useLogin } from "../../../../context/LoginContext";
import localStorageKey from "../../../../enumerations/localStorageKey";
import { useGetUserWallet } from "../../../../hooks/wallet/wallet.hooks";
import { moneyFormat } from "../../../../plugins/numberFormat";
import { envChangeType, envType } from "../../../../plugins/utils";
import CSPopup from "../CSPopup";
import AllianceDrawer from "./components/AllianceDrawer";
import allianceBn from "./icon/alliance_bn.webp";
import allianceEn from "./icon/alliance_en.webp";
import styles from "./styleModule";

const LangHeader = ({
  style = {},
  logoStyle = "",
  showBalance = false,
  depositButtonStyle = "",
  showWallet = false,
  showAlliance = true,
  showRegisterBadge = true,
}) => {
  const CURRENCY = localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);
  const { isLogin, checkIfLogin } = useLogin();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [allianceDrawerOpen, setAllianceDrawerOpen] = useState(false);

  const { error: walletError, data: walletData } = useGetUserWallet({
    enabled: !!isLogin && showWallet,
  });

  const onHandleDepositOpen = () => {
    if (!checkIfLogin()) return;
    navigate("/exchange?tab=deposit");
  };

  const renderBalance = () => {
    const renderAllianceButton = () => {
      if (!showAlliance) return null;
      const allianceImage = {
        bn: allianceBn,
        en: allianceEn,
      };
      return (
        <Image
          src={allianceImage[i18n.language] || allianceImage["en"]}
          alt="alliance"
          preview={false}
          className={styles.allianceImage}
          onClick={() => setAllianceDrawerOpen(true)}
        />
      );
    };
    if (isLogin) {
      return (
        <>
          {renderAllianceButton()}
          <div className={styles.balanceArea}>
            {showWallet && (
              <>
                <span className={styles.moneySymbol}>
                  {t(`currency.symbol.${CURRENCY.toUpperCase()}`)}
                </span>
                <div className={`${styles.moneyGroup}`}>
                  <span className={`${styles.money}`}>
                    {walletData?.money ? moneyFormat(walletData.money).split(".")[0] : "0"}
                  </span>
                  {moneyFormat(walletData?.money).split(".")[1] !== "0" &&
                  envChangeType("REACT_APP_MIN_DECIMAL_POINT", envType.NUMBER) > 0 ? (
                    <span className={`${styles.moneyFraction}`}>
                      .{walletData?.money ? moneyFormat(walletData.money).split(".")[1] : "00"}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className={`${styles.depositButton} ${depositButtonStyle}`}
                  onClick={onHandleDepositOpen}
                >
                  <PlusOutlined style={{ color: "#fff" }} />
                </div>
              </>
            )}
          </div>
        </>
      );
    }
    return (
      <div className={styles.buttonContainer}>
        {renderAllianceButton()}
        <CustomButton type="default" onClick={toLogin}>
          {t("normal.login")}
        </CustomButton>
        <div className={styles.registerBadgeWrapper}>
          <CustomButton type="primary" onClick={toSignUp}>
            {t("normal.register")}
          </CustomButton>
          {showRegisterBadge && (
            <span className={styles.registerBadge}>
              {t(`currency.symbol.${CURRENCY.toUpperCase()}`)}17
            </span>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.header} style={{ ...style }}>
      <img
        className={`${styles.logo} ${logoStyle}`}
        src={`/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/topbar_logo.png`}
        alt={envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}
      />
      <div className={styles.rightContainer}>{showBalance === true ? renderBalance() : null}</div>
      <CSPopup
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
      />
      <AllianceDrawer open={allianceDrawerOpen} onClose={() => setAllianceDrawerOpen(false)} />
    </div>
  );
};

export default LangHeader;
